import React from 'react';
import './index.css';

function Article() {
  return (
    <div className='shorts'>
      <h4>¡Mirá que fácil es usar Cuenta DNI!</h4>
      <div className="videos-grid">
        <div className="embed-container">
          <div className='embed-responsive embed-responsive-16by9 with-curves'>
            <iframe width="560" height="315" src="https://www.youtube.com/embed/O8g13IjGDHo?si=fAbOCKnXXeF2pyA-" title="Cambiá tu foto de perfil" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
          </div>
          <h5>Cambiá tu foto de perfil</h5>
        </div>
        <div className="embed-container">
          <div className='embed-responsive embed-responsive-16by9 with-curves'>
            <iframe width="560" height="315" src="https://www.youtube.com/embed/Cfwj70sf1Bc?si=fAbOCKnXXeF2pyA-" title="Cambiá tu alias" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
          </div>
          <h5>Cambiá tu alias</h5>
        </div>
        <div className="embed-container">
          <div className='embed-responsive embed-responsive-16by9 with-curves'>
            <iframe width="560" height="315" src="https://www.youtube.com/embed/DAnTXBOFYok?si=fAbOCKnXXeF2pyA-" title="Como ingresar dinero…" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
          </div>
          <h5>Como ingresar dinero…</h5>
        </div>
        <div className="embed-container">
          <div className='embed-responsive embed-responsive-16by9 with-curves'>
            <iframe width="560" height="315" src="https://www.youtube.com/embed/ksMuIfiIqL0?si=fAbOCKnXXeF2pyA-" title="¿Cómo extraer dinero?" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
          </div>
          <h5>¿Cómo extraer dinero?</h5>
        </div>
      </div>
    </div>
  );
}

export default Article;
